import { render, staticRenderFns } from "./InternalLinkBtn.vue?vue&type=template&id=d9248ab8"
import script from "./InternalLinkBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalLinkBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports